import { URLSearchParams } from "url";
import { RequestDataQuery } from "../../../api/data-types";
import { LatestInputState } from "./data-types/input-state";

export const avaiableSearchTypes: string[] = [
  "Metadata",
  "Gdrive",
  "Folder pattern",
];

export const updateRequestDataLimit = (
  prevData: RequestDataQuery,
  limit: number
): RequestDataQuery => {
  return new RequestDataQuery(
    prevData.folders,
    prevData.files,
    prevData.path,
    prevData.containerName,
    prevData.parentFolder,
    prevData.currentContinuationToken,
    prevData.nextContinuationToken,
    prevData.previousContinuationToken,
    limit,
    prevData.moreDataAvaiable
  );
};

export const updateRequestDataContainer = (
  prevData: RequestDataQuery,
  container: string
): RequestDataQuery => {
  return new RequestDataQuery(
    prevData.folders,
    prevData.files,
    prevData.path,
    container,
    prevData.parentFolder,
    prevData.currentContinuationToken,
    prevData.nextContinuationToken,
    prevData.previousContinuationToken,
    prevData.limit,
    prevData.moreDataAvaiable
  );
};

export const updateUrlWithSelectedSearch = (
  searchParams: URLSearchParams,
  latestSearchInput: LatestInputState
) => {
  const metadataPattern = /metadata\..+$/;
  const gdrivePattern = /gdrive\..+$/;
  const folderSearchPattern = /pattern\..+$/;

  async function removeMatchingKeys(pattern1: RegExp, pattern2: RegExp) {
    for (const key of searchParams.keys()) {
      if (pattern1.test(key) || pattern2.test(key)) {
        searchParams.delete(key);
      }
    }
  }

  const searchType = searchParams.get("search");
  switch (searchType) {
    case avaiableSearchTypes[0]:
      //Metadata
      searchParams.set(
        "metadata.metaDataKey",
        latestSearchInput.metadataInput.metaDataKey
      );
      searchParams.set(
        "metadata.metaDataValue",
        latestSearchInput.metadataInput.metaDataValue
      );
      searchParams.set(
        "metadata.folder",
        latestSearchInput.metadataInput.folder ?? ""
      );
      removeMatchingKeys(gdrivePattern, folderSearchPattern);
      break;
    case avaiableSearchTypes[1]:
      //Gdrive
      searchParams.set(
        "gdrive.GdriveLink",
        latestSearchInput.gdriveInput.GdriveLink
      );
      removeMatchingKeys(metadataPattern, folderSearchPattern);
      break;
    case avaiableSearchTypes[2]:
      //Folder pattern
      searchParams.set(
        "pattern.folderPattern",
        latestSearchInput.folderPatternInput.folderPattern ?? ""
      );
      searchParams.set(
        "pattern.fileName",
        latestSearchInput.folderPatternInput.fileName ?? ""
      )
      removeMatchingKeys(metadataPattern, gdrivePattern);
      break;
    case "":
      //search type not selected
      break;
    default:
      console.error("Wrong search type!");
  }
};

export const removeSearchTypeValueSearchParams = (
  searchParams: URLSearchParams
) => {
  const pattern = /(metadata|gdrive|pattern)\..+/;

  for (const key of searchParams.keys()) {
    if (pattern.test(key)) {
      searchParams.delete(key);
    }
  }
};

export const wasChangeSignificant = (
  oldSearchParams: URLSearchParams,
  searchParams: URLSearchParams
): boolean => {
  if (
    oldSearchParams.get("container") === searchParams.get("container") &&
    oldSearchParams.get("folder") === searchParams.get("folder") &&
    oldSearchParams.get("search") === searchParams.get("search") &&
    oldSearchParams.get("limit") !== searchParams.get("limit")
  ) {
    return false;
  }
  return true;
};
